import Appsignal from "@appsignal/javascript";
import { ErrorBoundary } from "@appsignal/react";

export default function AppsignalProvider({ children }: { children: React.ReactNode }) {
  const appsignal = new Appsignal({
    key: process.env.NEXT_PUBLIC_APPSIGNAL_FRONTEND_KEY,
    revision: process.env.NEXT_PUBLIC_REVISION,
  });

  return (
    <ErrorBoundary
      instance={appsignal}
      // tags={{ requestId: pageProps.requestId, sessionId: pageProps.sessionId }}
    >
      {children}
    </ErrorBoundary>
  );
}
